import * as Output from '../../Text';

export const phoneNumberValidation = (field, fields) => {
  if (field) {
    if (field.length < 3) {
      return Output.resolve(
        'generic.errors.M003b_minNumberOfCharacters',
      );
    }
    if (field.length > 15) {
      return Output.resolve(
        'generic.errors.M003a_maxNumberOfCharacters',
      );
    }
    if (field[0] === '0') {
      return Output.resolve(
        'generic.errors.M013_ValidPhoneNumber',
      );
    }
    if(!/^\d+$/.test(field)) {
      return Output.resolve('generic.errors.M002_invalidCharacters');
    }
  }
  return undefined;
};
